export const getColors = (mode) =>
  ({
    dark: {
      bgColor: "#2F2B3D",
      headingColor: "#FFFFFF",
      textColor: "#FFFFFF",
      arrowColor: "#2F2B3D",
      cardBg: "#FFFFFF1A",
      borderColor: "#FFFFFF33",
    },
    light: {
      bgColor: "#FFFFFF",
      headingColor: "rgba(62, 63, 76, 1)",
      textColor: "rgba(47, 43, 61, 1)",
      arrowColor: "#FFFFFF",
      cardBg: "#F5F5F5",
      borderColor: "rgba(230, 228, 235, 1)",
    },
  }[mode] || {});

export const tooltipSx = (colors) => ({
  backgroundColor: colors.bgColor,
  color: colors.textColor,
  padding: "16px",
  borderRadius: "8px",
  maxWidth: "none",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  "& .MuiTooltip-arrow": {
    color: colors.arrowColor,
  },
});

export const arrowSx = (colors) => ({
  color: colors.arrowColor,
});

export const tooltipWrapper = {
  maxWidth: 300,
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

export const tooltipHeading = (colors) => ({
  fontSize: "14px",
  fontWeight: "500",
  mb: "12px",
  color: colors.headingColor,
});

export const supplierBoxWrapper = {
  maxHeight: "200px",
  overflow: "auto",
  paddingRight: "4px",
};

export const supplierBox = (borderColor) => ({
  border: `1px solid ${borderColor}`,
  borderRadius: "8px",
  // maxHeight: "200px",
  // overflow: "auto",
});

export const supplierRow = (isLast, borderColor) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: isLast ? "none" : `1px solid ${borderColor}`,
});

export const supplierInfo = (borderColor) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  p: "12px",
  borderRight: `1px solid ${borderColor}`,
});

export const supplierName = (textColor) => ({
  fontSize: "13px",
  fontWeight: "400",
  color: textColor,
});

export const supplierPrice = (textColor) => ({
  fontSize: "14px",
  fontWeight: "400",
  color: textColor,
});

export const priceBox = {
  width: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const imageWrapper = {
  width: "100%",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const imageStyle = {
  width: "134px",
  height: "113px",
  objectFit: "cover",
  borderRadius: 4,
};

export const navButton = {
  position: "absolute",
  color: "#fff",
  background: "rgba(0,0,0,0.3)",
  width: "24px",
  height: "24px",
  "&:hover": {
    background: "rgba(0,0,0,0.5)",
  },
};

export const leftNavButton = {
  ...navButton,
  left: 0,
};

export const rightNavButton = {
  ...navButton,
  right: 0,
};

export const imageContainer = {
  maxWidth: 300,
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};
